import { render, staticRenderFns } from "./CalcStepLoads.vue?vue&type=template&id=b2f187ac&scoped=true&"
import script from "./CalcStepLoads.vue?vue&type=script&lang=js&"
export * from "./CalcStepLoads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f187ac",
  null
  
)

export default component.exports